import { useContext, useState } from "react";
import PillValidacionCedula from "../../../../ui/groups/PillValidacionCedula";
import { useColumnVisibility } from "../../../../../context/ColumnVisibilityContext";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import IconRegistroCompleto from "../../../../ui/icons-seleccion/candidatoValidado/IconRegistroCompleto";
import IconRegistroRechazado from "../../../../ui/icons-seleccion/candidatoValidado/IconRegistroRechazado";
import IconBloquear from "../../../../ui/icons-seleccion/IconBloquear";
import IconRegistroCandidato from "../../../../ui/icons-seleccion/IconRegistroCandidato";
import IconDescarte from "../../../../ui/icons-seleccion/IconDescarte";
import IconSolicitarCandidato from "../../../../ui/icons-seleccion/IconSolicitarCandidato";
import SeleccionContext from "../../../../../context/Seleccion/SeleccionContext";
import ModalEncuesta from "../../../Campaign/ModalEncuesta";
import ModalUpdateCandidate from "../../../../ui/kit-mdtw/modals/modalUpdateCandidate/ModalUpdateCandidate";
import ModalGenerico from "../../../../ui/kit-modal/ModalGenerico";
import ModalDescartarBloquear from "../../../../ui/kit-modal/bloquearDescartar/ModalDescartarBloquear";
import ModalSolicitarRegistro from "../../RegistroPorValidarMasivo/Modal/ModalSolicitarRegistro";
import { formatDateToDDMMAAAA } from "../../../../../functions/kit-mdtw/dates";
import {
  ICandidatoValidadoPersona,
  IMovilizacionTw,
} from "../../../../../interfaces/ISeleccion";
import Tooltip from "../../../../ui/kit-mdtw/tooltip/Tooltip";
import CircularProgress from "@mui/material/CircularProgress";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import { downloadFichaLegacyByRuts } from "../../../../../services/fichaLegacyService";

interface IHandleClickAddOrRemoveChoise {
  personaDNI: string;
}

interface ITablaCandidato {
  listaPersona: any;
  listaSeleccionProceso: string[];
  localStorageFilter: string;
  formFilter: any;
  listRefresh: Function;
  setListadoSeleccionado: Function;
  handleClickAddOrRemoveChoise: (values: IHandleClickAddOrRemoveChoise) => void;
  busquedaId?: string;
}

const TablaCandidato = (props: ITablaCandidato) => {
  const {
    listaPersona,
    handleClickAddOrRemoveChoise,
    listaSeleccionProceso,
    localStorageFilter,
    formFilter,
    listRefresh,
    setListadoSeleccionado,
    busquedaId,
  } = props;
  const { isColumnVisible } = useColumnVisibility();
  const {
    listMovilizacionTw,
    putMetodoMovilizacion,
    putConfirmarEntrevista,
    getRutVerificado,
    getDocument,
    token,
    userId,
    postSolicitarCandidato,
  } = useContext(SeleccionContext);
  const [isOpenModalCampaign, setIsOpenModalCampaign] =
    useState<boolean>(false);
  const [isOpenModalBloquear, setIsOpenModalBloquear] =
    useState<boolean>(false);
  const [isOpenModalDescartar, setIsOpenModalDescartar] =
    useState<boolean>(false);
  const [candidateSelect, setCandidateSelect] = useState<any[]>([]);
  const [resultBusperId, setResultBusperId] = useState<string | undefined>(
    undefined
  );
  const [isOpenModalUpdateCandidate, setIsOpenModalUpdateCandidate] =
    useState<boolean>(false);
  const [selectedReclutadorId, setSelectedReclutadorId] = useState<string | undefined>(undefined);
  const [selectedReclutador, setSelectedReclutador] = useState<string | undefined>(undefined);
  const [buttonDisabled, setButtonDisabled] = useState<boolean>(true);
  const [isFree, setIsFree] = useState<boolean | undefined>(undefined);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [loadingRut, setLoadingRut] = useState<string | null>(null);
  const [messageSpanish, setMessageSpanish] = useState<string>(
    "Ingrese Rut y presione Revisar Rut para consultar su estado en el sistema"
  );
  const [isOpenModalSolicitar, setIsOpenModalSolicitar] = useState<boolean>(false);
  const [candidateSelectSolicitar, setCandidateSelectSolicitar] = useState<string[]>([]);
  const [candidatesSolicitar, setCandidatesSolicitar] = useState<any[]>([]);
  const [solicitudes, setSolicitudes] = useState<any>([]);
  const [selectedProcesoDestino, setSelectedProcesoDestino] = useState<string | undefined>(undefined);
  const [selectedComentario, setSelectedComentario] = useState<string>("");
  const [loadingFichaRut, setLoadingFichaRut] = useState<string | null>(null);

  const handleDownloadFichaRow = async (personaDNI: string, busPerId?: string): Promise<void> => {
    if (loadingFichaRut) return;
    setLoadingFichaRut(personaDNI);
    try {
      await downloadFichaLegacyByRuts([{ rut: personaDNI, busPerId }]);
    } catch (error) {
      console.log("ERROR DESCARGANDO FICHA", error);
    } finally {
      setLoadingFichaRut(null);
    }
  };

  const handleClickVerificarRut = (rowData: any) => {
    const { personaDNI, busPerId, reclutadorId, reclutador } = rowData;
    setCandidateSelect([personaDNI]);
    setSelectedReclutadorId(reclutadorId);
    setSelectedReclutador(reclutador);
    setLoadingRut(personaDNI);
    getRutVerificado({
      personaRut: personaDNI,
      busPerId,
      setIsFree,
      setMessageSpanish,
      setLoading: (val: boolean) => { setIsLoading(val); if (!val) setLoadingRut(null); },
      setButtonDisabled,
      consultaRut: false,
      setIsOpenModalUpdateCandidate,
      token,
    });
    getDocument({ personaDNI: personaDNI, token });
  };

  const handleClickBloquearCandidato = (values: any) => {
    const { personaDNI } = values;
    setCandidateSelect([personaDNI]);
    setIsOpenModalBloquear(true);
  };

  const handleClickDescartarCandidato = (values: any) => {
    const { personaDNI } = values;
    setCandidateSelect([personaDNI]);
    setIsOpenModalDescartar(true);
  };

  const handleClickSolicitar = (values: any): void => {
    const { personaDNI, primerNombre, primerApellido, reclutador } = values;
    setIsOpenModalSolicitar(true);
    setCandidateSelectSolicitar([personaDNI]);
    setCandidatesSolicitar([{ busquedaId, primerNombre, primerApellido, reclutador, fechaCreacion: undefined }]);
  };

  const handleClickSolicitarCandidato = async (args?: { procesoDestino?: string; comentario?: string }): Promise<void> => {
    const procesoId = args?.procesoDestino ?? selectedProcesoDestino;
    const comentario = args?.comentario ?? selectedComentario ?? "";
    if (token && procesoId) {
      await postSolicitarCandidato({
        token,
        solicitudes: candidateSelectSolicitar.map((dni: string) => {
          const candidate = listaPersona?.find((c: any) => c.personaDNI === dni);
          return { personaId: candidate?.personaId ?? dni, procesoId, comentario };
        }),
      });
    }
  };

  const handleClickConfirmarEntrevista = async (values: any) => {
    const { busPerId, newStatus } = values;
    const candidates = {
      busPerId,
      confirmaEntrevista: newStatus,
    };
    try {
      if (token) {
        await putConfirmarEntrevista({ token, personas: [candidates] });
        await listRefresh();
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleClickTransporteTw = async (values: any) => {
    const { busPerId, status } = values;
    try {
      if (token && listMovilizacionTw && status) {
        const currentState = listMovilizacionTw.find(
          ({ nombre }: IMovilizacionTw) => nombre !== status
        );
        const body = {
          busPerId,
          movilizacionId: currentState.movilizacionId ?? "",
        };
        await putMetodoMovilizacion({ token, body: [body] });
        await listRefresh();
      }
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <>
      {listaPersona &&
        listaPersona.map((items: ICandidatoValidadoPersona) => {
          const {
            busPerId,
            personaDNI,
            reclutadorId,
            primerNombre,
            fonoPrincipal,
            primerApellido,
            fechaValidacion,
            confirmaEntrevista,
            movilizacion,
            estadoRegistro,
            reclutador,
          } = items;
          return (
            <>
              <tr
                className={`tr-table-registros ${
                  listaSeleccionProceso.includes(personaDNI) && "checkeado"
                }`}
                key={busPerId}
              >
                <td className="td-table-procesos">
                  <button
                    className="button-select"
                    onClick={() => handleClickAddOrRemoveChoise({ personaDNI })}
                  >
                    {listaSeleccionProceso.includes(personaDNI) ? (
                      <CheckBoxIcon />
                    ) : (
                      <CheckBoxOutlineBlankIcon />
                    )}
                  </button>
                </td>
                {isColumnVisible("estado") && (
                <td className="td-table-procesos">
                  <section className="content-state">
                    {estadoRegistro === "COMPLETO" && (
                      <>
                        <IconRegistroCompleto fill="#06A502" />
                        <div className="content-state-text">
                          <label className="title registro-completo">
                            Registro Completo
                          </label>
                          <label className="message">
                            Datos requeridos <br></br>
                            completos
                          </label>
                        </div>
                      </>
                    )}
                    {estadoRegistro === "INCOMPLETO" && (
                      <>
                        <IconRegistroCompleto fill="#E3A000" />
                        <div className="content-state-text">
                          <label className="title registro-incompleto">
                            Registro Incompleto
                          </label>
                          <label className="message">
                            Datos requeridos <br></br>
                            incompleto
                          </label>
                        </div>
                      </>
                    )}
                    {estadoRegistro === "RECHAZADO" && (
                      <>
                        <IconRegistroRechazado fill="#BE2A2A" />
                        <div className="content-state-text">
                          <label className="title solicitud-rechazada">
                            Registro Rechazado
                          </label>
                          <label className="message">
                            Registro devuelto para <br></br>
                            corrección
                          </label>
                        </div>
                      </>
                    )}
                  </section>
                </td>
                )}
                {isColumnVisible("validacion") && (
                <td className="td-table-procesos col-w-validacion">
                  <PillValidacionCedula
                    veredictoCedula={items.veredictoCedula}
                    detalleCedula={items.detalleCedula}
                  />
                </td>
                )}
                {isColumnVisible("nombre") && (
                <td className="td-table-procesos">
                  {primerNombre} {primerApellido}
                </td>
                )}
                {isColumnVisible("rut") && <td className="td-table-procesos">{personaDNI}</td>}
                {isColumnVisible("celular") && <td className="td-table-procesos">{fonoPrincipal}</td>}
                {isColumnVisible("fechaValidacion") && (
                <td className="td-table-procesos">
                  {formatDateToDDMMAAAA({
                    date: fechaValidacion,
                    format: "/",
                  })}
                </td>
                )}
                {isColumnVisible("reclutador") && <td className="td-table-procesos">{reclutador}</td>}
                {isColumnVisible("confirmaEntrevista") && (
                <td className="td-table-procesos">
                  <div className="content-icon-table">
                    <button
                      className="button-content"
                      onClick={() =>
                        handleClickConfirmarEntrevista({
                          busPerId,
                          newStatus: !confirmaEntrevista,
                        })
                      }
                    >
                      {confirmaEntrevista ? (
                        <CheckBoxIcon />
                      ) : (
                        <CheckBoxOutlineBlankIcon />
                      )}
                    </button>
                  </div>
                </td>
                )}
                <td className="td-table-procesos">
                  <div className="content-icon-table">
                    <Tooltip text="Ver Registro">
                      <button
                        onClick={() =>
                          handleClickVerificarRut({ personaDNI, busPerId, reclutadorId, reclutador })
                        }
                        className="button-content"
                        disabled={loadingRut === personaDNI}
                      >
                        {loadingRut === personaDNI ? (
                          <CircularProgress size={18} thickness={4} sx={{ color: "#0065DD" }} />
                        ) : (
                          <IconRegistroCandidato fill={"#0065DD"} />
                        )}
                      </button>
                    </Tooltip>
                    <Tooltip text={loadingFichaRut === personaDNI ? "Generando ficha…" : "Descargar Ficha"}>
                      <button
                        onClick={() => handleDownloadFichaRow(personaDNI, busPerId)}
                        className="button-content"
                        disabled={loadingFichaRut === personaDNI}
                      >
                        {loadingFichaRut === personaDNI ? (
                          <CircularProgress size={18} thickness={4} sx={{ color: "#0065DD" }} />
                        ) : (
                          <PictureAsPdfIcon style={{ fontSize: 20, color: "#D32F2F" }} />
                        )}
                      </button>
                    </Tooltip>
                    {reclutadorId !== userId && (
                      <Tooltip text="Solicitar Candidato">
                        <button
                          className="button-content"
                          onClick={() => handleClickSolicitar({ personaDNI, primerNombre, primerApellido, reclutador })}
                        >
                          <IconSolicitarCandidato fill={"#E3A000"} />
                        </button>
                      </Tooltip>
                    )}
                    <Tooltip text="Bloquear">
                      <button
                        onClick={() =>
                          handleClickBloquearCandidato({ personaDNI })
                        }
                        className="button-content"
                      >
                        <IconBloquear fill={"#BE2A2A"} />
                      </button>
                    </Tooltip>
                    <Tooltip text="Descartar">
                      <button
                        onClick={() =>
                          handleClickDescartarCandidato({ personaDNI })
                        }
                        className="button-content"
                      >
                        <IconDescarte fill={"#BE2A2A"} />
                      </button>
                    </Tooltip>
                  </div>
                </td>
              </tr>
            </>
          );
        })}

      {isOpenModalUpdateCandidate && (
        <ModalUpdateCandidate
          title="Registro Candidato"
          subTitle="Puede cambiar al candidato de proceso en cualquier momento, Todos los datos con (*) son obligatorios y deben ser completados antes de avanzar al candidato a la siguiente etapa del proceso."
          setIsOpenModalUpdateCandidate={setIsOpenModalUpdateCandidate}
          setResultBusperId={setResultBusperId}
          requerido
          token={token}
          isLoadingModal={isLoading}
          rut={candidateSelect[0]}
          reclutadorId={selectedReclutadorId}
          reclutador={selectedReclutador}
          getCandidates={listRefresh}
          onChangeBack={() => {
            setIsOpenModalUpdateCandidate(false);
            const body = document.querySelector("body");
            if (body) {
              body.style.overflowY = "auto";
            }
          }}
          onChangeGo={() => {
            const body = document.querySelector("body");
            if (body) {
              body.style.overflowY = "auto";
            }
          }}
        />
      )}

      {isOpenModalCampaign && (
        <ModalEncuesta
          modalStyle="confirm"
          title="Solicite realizar la siguiente encuesta al candidato"
          onChangeBack={() => {
            setIsOpenModalCampaign(false);
            const body = document.querySelector("body");
            if (body) {
              body.style.overflowY = "auto";
            }
          }}
          buttonBack="Cancelar"
          busPerId={resultBusperId}
        />
      )}

      {isOpenModalBloquear && (
        <ModalGenerico
          title="BLOQUEO DE CANDIDATOS"
          width="w-70"
          subtitle="Estás por bloquear la siguiente selección de candidatos:"
          onChangeBack={() => {
            setIsOpenModalBloquear(false);
            const body = document.querySelector("body");
            if (body) {
              body.style.overflowY = "auto";
            }
          }}
        >
          <ModalDescartarBloquear
            typeExclusion="bloqueo"
            getListRefresh={listRefresh}
            listSelect={listaPersona ?? []}
            localStorageFilter={localStorageFilter}
            setListadoSeleccionado={setListadoSeleccionado}
            formFilter={formFilter}
            onChangeBack={() => {
              setIsOpenModalBloquear(false);
              const body = document.querySelector("body");
              if (body) {
                body.style.overflowY = "auto";
              }
            }}
            list={candidateSelect}
          />
        </ModalGenerico>
      )}

      {isOpenModalDescartar && (
        <ModalGenerico
          title="DESCARTE DE CANDIDATOS"
          width="w-70"
          subtitle="Estás por descartar la siguiente selección de candidatos:"
          onChangeBack={() => {
            setIsOpenModalDescartar(false);
            const body = document.querySelector("body");
            if (body) {
              body.style.overflowY = "auto";
            }
          }}
        >
          <ModalDescartarBloquear
            typeExclusion="descarte"
            getListRefresh={listRefresh}
            listSelect={listaPersona ?? []}
            setListadoSeleccionado={setListadoSeleccionado}
            localStorageFilter={localStorageFilter}
            formFilter={formFilter}
            onChangeBack={() => {
              setIsOpenModalDescartar(false);
              const body = document.querySelector("body");
              if (body) {
                body.style.overflowY = "auto";
              }
            }}
            list={candidateSelect}
          />
        </ModalGenerico>
      )}

      {isOpenModalSolicitar && (
        <ModalGenerico
          title="Solicitar Candidato"
          width="w-90"
          buttonBackText="Cerrar"
          buttonGoText="Solicitar"
          buttonGoStyle="confirm"
          buttonGoDisable={!!selectedProcesoDestino}
          onChangeBack={() => {
            setIsOpenModalSolicitar(false);
            setCandidateSelectSolicitar([]);
            setSolicitudes([]);
            setSelectedProcesoDestino(undefined);
            setSelectedComentario("");
          }}
          onChangeGo={() => {
            handleClickSolicitarCandidato({ procesoDestino: selectedProcesoDestino, comentario: selectedComentario });
            setIsOpenModalSolicitar(false);
            setCandidateSelectSolicitar([]);
            setSelectedProcesoDestino(undefined);
            setSelectedComentario("");
          }}
        >
          <ModalSolicitarRegistro
            rut={candidateSelectSolicitar}
            candidates={candidatesSolicitar}
            solicitudes={solicitudes}
            setSolicitudes={setSolicitudes}
            onChangeBack={() => {
              setIsOpenModalSolicitar(false);
              setCandidateSelectSolicitar([]);
              setCandidatesSolicitar([]);
              setSolicitudes([]);
              setSelectedProcesoDestino(undefined);
              setSelectedComentario("");
            }}
            handleClickSolicitarCandidato={handleClickSolicitarCandidato}
            onSelectProceso={(value: string) => setSelectedProcesoDestino(value)}
            onComentario={(value: string) => setSelectedComentario(value)}
          />
        </ModalGenerico>
      )}
    </>
  );
};

export default TablaCandidato;
